module.exports = __webpack_public_path__ + "logo-lightspeed.e016737b6cdbc72e18dd87b748b62e19.svg";